The category of a job's occupation.
